"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var ResponceComment = function (props) {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, react_1.useState)(), comment = _b[0], setComment = _b[1];
    var images = ["image1xs.svg", "image2xs.svg"];
    (0, react_1.useEffect)(function () {
        if (props.comment) {
            setComment(props.comment);
        }
    }, [props]);
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)("__responce-item", (!(comment === null || comment === void 0 ? void 0 : comment.flag_moderation)) && "__on-moderation-responce") },
            react_1.default.createElement("div", { className: "__user-info" },
                react_1.default.createElement("div", { className: "__user-avatar" },
                    react_1.default.createElement("div", { className: "__circle-avatar" },
                        react_1.default.createElement("img", { src: "/images/app/comments/".concat(images[Math.floor(Math.random() * images.length)]) }))),
                react_1.default.createElement("div", { className: "__comment-user-data-responce" },
                    react_1.default.createElement("div", { className: "__name-response" }, comment === null || comment === void 0 ? void 0 : comment.user_name),
                    react_1.default.createElement("div", { className: "__time-response" }, comment && comment.timestamp_create && moment_1.default.unix(comment.timestamp_create).format("HH:mm DD/MM/YYYY")))),
            react_1.default.createElement("div", { className: "__user-comment" }, comment === null || comment === void 0 ? void 0 : comment.comment),
            !(comment === null || comment === void 0 ? void 0 : comment.flag_moderation) &&
                react_1.default.createElement("div", { className: "__moderation-text" }, t("comments.auth.moderation.text")))));
};
exports.default = ResponceComment;
